import { orderBy } from 'lodash'

export default {
    getLabels: state => {
        return orderBy(state.labels, 'id', 'desc')
    },
    getLabelById: state => id => {
        return state.labels.find(label => label.id == id)
    },
    getProductsName: state => {
        return orderBy(state.products.map(product => product.name))
    }
}
